import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import axios from "axios";
import "./assets/css/key-frames.css";
import Login from '@/components/Login';
import Vue2TouchEvents from 'vue2-touch-events';
import './registerServiceWorker';

let productionTip = false;
let appName = 'VecView';
let pageName = '';
let appTokenKey = 'appToken';
let appUserKey = 'appUser';

Vue.config.productionTip = productionTip;

Vue.prototype.$appName = appName;
Vue.prototype.$pageName = pageName;
Vue.prototype.$appTokenKey = appTokenKey;
Vue.prototype.$appUserKey = appUserKey;
Vue.prototype.$appMessages = {
    "err404": "Acesso não autorizado!",
    "loginInvalid": "Não foi possível efetuar o login, confirme seu nome de usuário e senha"
};
Vue.prototype.$updNowEvt = "appUpdateNowEvent";
Vue.prototype.$instanceChangeEvt = "instanceChangeEvt";
Vue.prototype.$updNowLevels = {
    "level1": 1,
    "level2": 2
};
Vue.prototype.$datetimeLayouts = [
    {
        "id": 1,
        "layout": "hhiissddmmyy",
        "positions": {
            "h": [0, 2],
            "i": [2, 2],
            "s": [4, 2],
            "d": [6, 2],
            "m": [8, 2],
            "y": [10, 2]
        }
    }
];

axios.getHeaders = function () {
    const token2 = window.localStorage.getItem(appTokenKey);
    return {
        headers: {
            "Authorization": `Bearer ${token2}`,
            "Access-Control-Allow-Origin": "*"
        }
    };
};

Vue.use(Vue2TouchEvents);

new Vue({
    router,
    vuetify,
    Login,
    render: h => h(App),
}).$mount('#app');